import { z } from "zod";

export const PaymentMethodSchema = z.enum([
  "zelle",
  "venmo",
  "card_link",
  "check",
  "cash",
]);
export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  zelle: "Zelle",
  venmo: "Venmo",
  card_link: "Card link",
  check: "Check",
  cash: "Cash",
};

export const PaymentSchema = z.object({
  id: z.string(),
  invoice_id: z.string(),
  method: PaymentMethodSchema,
  amount_cents: z.number(),
  received_at: z.string(),
  reference: z.string().nullable(),
});
export type Payment = z.infer<typeof PaymentSchema>;

export const PaymentListResponseSchema = z.object({
  items: z.array(PaymentSchema),
});
export type PaymentListResponse = z.infer<typeof PaymentListResponseSchema>;

// ---- Mutation inputs -----------------------------------------------------

export interface AddPaymentInput {
  invoiceId: string;
  method: PaymentMethod;
  amount_cents: number;
  received_at?: string;
  reference?: string | null;
}
